import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { FaArrowLeft, FaPencilAlt, FaPhone, FaFax, FaEnvelope, FaGlobe, FaMapMarkerAlt, FaClock } from 'react-icons/fa';

const FacilityDetails = () => {
        const { id } = useParams();

        // Mock facility data - replace with actual API call
        const [facility] = useState({
                id: 1,
                name: 'Monash House Private Hospital',
                type: 'Hospital',
                category: 'Private',
                address: {
                        street: '252 Clayton Road',
                        suburb: 'Clayton',
                        state: 'VIC',
                        postcode: '3168',
                        country: 'Australia'
                },
                contacts: {
                        phone: '0385551234',
                        fax: '0385551235',
                        email: 'info@monashhouse.com.au',
                        website: 'www.monashhouse.com.au'
                },
                providerNumbers: {
                        medicare: '0123456A',
                        dva: 'DVA123456',
                        healthFund: 'HF123456'
                },
                operatingHours: {
                        monday: '8:00 AM - 6:00 PM',
                        tuesday: '8:00 AM - 6:00 PM',
                        wednesday: '8:00 AM - 6:00 PM',
                        thursday: '8:00 AM - 6:00 PM',
                        friday: '8:00 AM - 6:00 PM',
                        saturday: '9:00 AM - 1:00 PM',
                        sunday: 'Closed'
                },
                departments: ['Emergency', 'Surgery', 'Radiology', 'Pathology'],
                status: 'Active',
                notes: 'Level 2 trauma center with full surgical capabilities'
        });

        const formatPhoneNumber = (phone) => {
                const cleaned = phone.replace(/\D/g, '');
                return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2 $3');
        };

        return (
                <div className="p-6 max-w-7xl mx-auto">
                        {/* Header */}
                        <div className="flex justify-between items-center mb-8">
                                <div className="flex items-center gap-4">
                                        <Link to="/facilities" className="btn btn-ghost btn-circle">
                                                <FaArrowLeft className="w-5 h-5" />
                                        </Link>
                                        <h1 className="text-2xl font-semibold text-base-content">{facility.name}</h1>
                                        <div className="badge badge-lg">{facility.status}</div>
                                </div>
                                <Link to={`/facilities/${id}/edit`} className="btn btn-primary">
                                        <FaPencilAlt className="w-4 h-4 mr-2" />
                                        Edit Facility
                                </Link>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                                {/* Main Information Card */}
                                <div className="card bg-base-100 shadow-xl">
                                        <div className="card-body">
                                                <h2 className="card-title mb-4">Facility Information</h2>

                                                <div className="grid gap-6">
                                                        <div className="grid grid-cols-2 gap-4">
                                                                <div>
                                                                        <label className="text-sm font-medium text-base-content/70">Facility Type</label>
                                                                        <div className="mt-1">{facility.type}</div>
                                                                </div>
                                                                <div>
                                                                        <label className="text-sm font-medium text-base-content/70">Category</label>
                                                                        <div className="mt-1">{facility.category}</div>
                                                                </div>
                                                        </div>

                                                        <div>
                                                                <label className="text-sm font-medium text-base-content/70 flex items-center gap-2">
                                                                        <FaMapMarkerAlt /> Address
                                                                </label>
                                                                <div className="mt-1">
                                                                        <div>{facility.address.street}</div>
                                                                        <div>{facility.address.suburb}, {facility.address.state} {facility.address.postcode}</div>
                                                                        <div>{facility.address.country}</div>
                                                                </div>
                                                        </div>

                                                        <div className="grid grid-cols-2 gap-4">
                                                                <div>
                                                                        <label className="text-sm font-medium text-base-content/70 flex items-center gap-2">
                                                                                <FaPhone /> Phone
                                                                        </label>
                                                                        <div className="mt-1">{formatPhoneNumber(facility.contacts.phone)}</div>
                                                                </div>
                                                                <div>
                                                                        <label className="text-sm font-medium text-base-content/70 flex items-center gap-2">
                                                                                <FaFax /> Fax
                                                                        </label>
                                                                        <div className="mt-1">{formatPhoneNumber(facility.contacts.fax)}</div>
                                                                </div>
                                                        </div>

                                                        <div>
                                                                <label className="text-sm font-medium text-base-content/70 flex items-center gap-2">
                                                                        <FaEnvelope /> Email
                                                                </label>
                                                                <div className="mt-1">{facility.contacts.email}</div>
                                                        </div>

                                                        <div>
                                                                <label className="text-sm font-medium text-base-content/70 flex items-center gap-2">
                                                                        <FaGlobe /> Website
                                                                </label>
                                                                <div className="mt-1">
                                                                        <a href={`https://${facility.contacts.website}`} target="_blank" rel="noopener noreferrer"
                                                                                className="link link-primary">
                                                                                {facility.contacts.website}
                                                                        </a>
                                                                </div>
                                                        </div>
                                                </div>
                                        </div>
                                </div>

                                {/* Provider Numbers Card */}
                                <div className="card bg-base-100 shadow-xl">
                                        <div className="card-body">
                                                <h2 className="card-title mb-4">Provider Information</h2>

                                                <div className="grid gap-6">
                                                        <div>
                                                                <label className="text-sm font-medium text-base-content/70">Medicare Provider Number</label>
                                                                <div className="mt-1">{facility.providerNumbers.medicare}</div>
                                                        </div>
                                                        <div>
                                                                <label className="text-sm font-medium text-base-content/70">DVA Provider Number</label>
                                                                <div className="mt-1">{facility.providerNumbers.dva}</div>
                                                        </div>
                                                        <div>
                                                                <label className="text-sm font-medium text-base-content/70">Health Fund Provider Number</label>
                                                                <div className="mt-1">{facility.providerNumbers.healthFund}</div>
                                                        </div>
                                                </div>
                                        </div>
                                </div>

                                {/* Operating Hours Card */}
                                <div className="card bg-base-100 shadow-xl">
                                        <div className="card-body">
                                                <h2 className="card-title mb-4 flex items-center gap-2">
                                                        <FaClock className="w-4 h-4" />
                                                        Operating Hours
                                                </h2>

                                                <div className="grid gap-2">
                                                        {Object.entries(facility.operatingHours).map(([day, hours]) => (
                                                                <div key={day} className="grid grid-cols-2 gap-4">
                                                                        <div className="font-medium capitalize">{day}</div>
                                                                        <div>{hours}</div>
                                                                </div>
                                                        ))}
                                                </div>
                                        </div>
                                </div>

                                {/* Departments & Notes Card */}
                                <div className="card bg-base-100 shadow-xl">
                                        <div className="card-body">
                                                <h2 className="card-title mb-4">Departments & Additional Information</h2>

                                                <div className="grid gap-6">
                                                        <div>
                                                                <label className="text-sm font-medium text-base-content/70">Departments</label>
                                                                <div className="mt-2 flex flex-wrap gap-2">
                                                                        {facility.departments.map((dept, index) => (
                                                                                <span key={index} className="badge badge-primary badge-lg">{dept}</span>
                                                                        ))}
                                                                </div>
                                                        </div>

                                                        <div>
                                                                <label className="text-sm font-medium text-base-content/70">Notes</label>
                                                                <div className="mt-1 text-base-content/80">{facility.notes}</div>
                                                        </div>
                                                </div>
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default FacilityDetails;